__turbopack_context__.v({
  "relateProductCard": "BlogDetails-module__THRPAG__relateProductCard",
});
